import { Reveal } from "../components/Reveal";

export default function SobreMi() {
  return (
    <section id="sobre-mi" data-testid="sobre-mi-section" className="py-24 md:py-36 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="overline mb-6">
            <span className="text-[#D7C6A3]">10</span> &nbsp;/&nbsp; Sobre mí
          </p>
          <h2 className="font-display text-4xl md:text-6xl text-[#2D3732] leading-[1.02]">
            Hola, soy Ana.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-8 space-y-6 text-[#4A554E] leading-relaxed font-light text-base md:text-lg max-w-2xl mx-auto">
            <p>
              No imaginé que mi historia como paciente acabaría convirtiéndose en un proyecto para
              ayudar a otras personas.
            </p>
            <p>
              Soy paciente de <strong className="font-normal text-[#2D3732]">síndromes compresivos
              vasculares</strong> y, tras años de consultas médicas, informes y tratamientos,
              comprendí que la organización también forma parte del cuidado de nuestra salud.
            </p>
            <p>
              Cada carpeta está <strong className="font-normal text-[#2D3732]">hecha a mano y
              diseñada por mí</strong> con mucho cariño, para llenar de color la vida de las personas
              que conviven con enfermedades crónicas y, sobre todo, con
              <strong className="font-normal text-[#2D3732]"> enfermedades invisibles</strong>.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 inline-block bg-[#F6F1E7] border border-[#E3E0D6] rounded-2xl px-8 py-5">
            <p className="font-display text-2xl text-[#8A9A6F] leading-snug">
              Toda la recaudación se destina íntegramente a mis enfermedades y a mi cuidado del día a día.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="font-display text-3xl md:text-4xl text-[#8A9A6F] leading-snug mt-12 max-w-2xl mx-auto">
            Por eso nació VITAE by Ana. Porque tu salud merece estar organizada.
          </p>
          <p className="overline mt-8">— Ana</p>
        </Reveal>
      </div>
    </section>
  );
}
